import state from "../state";
import renderBoard from "./renderBoard";
export default function undoLastStroke(mainCanvas, mainCtx) {
    const strokes = state.getStrokes();
    if (strokes.length > 0) {
        state.setStrokes(strokes.slice(0, -1));
        renderBoard(mainCanvas, mainCtx, state.getStrokes(), state.getCamera());
    }
}
